import * as ko from "knockout";
import Bao from "./../../services/bao-service";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-searcher";
function ExpandedSearchPerson(parent, initValues) {
    var self = this;
    var htmlUrl = "ExpandedSearchSynoset/ExpandedPerson";
    self.defaultValuesCopy = {};
    if (initValues != null) {
        for (var k in initValues) {
            if (ko.isObservable(initValues[k])) {
                self.defaultValuesCopy[k] = ko.observable(ko.unwrap(initValues[k]));
            }
            else {
                self.defaultValuesCopy[k] = initValues[k];
            }
        }
        self.defaultValuesCopy.CustomFilter = {};
        for (var k in initValues.CustomFilter) {
            if (ko.isObservable(initValues.CustomFilter[k])) {
                self.defaultValuesCopy.CustomFilter[k] = ko.observable(ko.unwrap(initValues.CustomFilter[k]));
            }
            else {
                self.defaultValuesCopy.CustomFilter[k] = initValues.CustomFilter[k];
            }
        }
    }
    self.LoadHtml = function () {
        return Bao.get(htmlUrl, function (result) {
            Bao.Templates[htmlUrl] = result;
            parent.ExpandedSearchTemplateName(htmlUrl);
        });
    };
    self.ShowShiftbook = ko.observable(false);
    self.ShowShiftgroup = ko.observable(false);
    self.ConfigurationItemTypeName = ko.observable();
    self.ConfigurationItemTypeId = ko.observable();
    self.ConfigurationItemTypeId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.ConfigurationItemStatusName = ko.observable();
    self.ConfigurationItemStatusId = ko.observable();
    self.ConfigurationItemStatusId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.QualificationId = ko.observable();
    self.QualificationName = ko.observable();
    self.QualificationId.subscribe(function () {
        if (initValues != null) {
            var defaultFilter = initValues.CustomFilter;
            if (defaultFilter != null) {
                defaultFilter.QualificationId = JSON.stringify(self.QualificationId());
            }
        }
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.WorkplaceId = ko.observable();
    self.WorkplaceName = ko.observable();
    self.WorkplaceId.subscribe(function () {
        if (initValues != null) {
            var defaultFilter = initValues.CustomFilter;
            if (defaultFilter != null) {
                if (self.HelperIsIdGiven(self.WorkplaceId())) {
                    defaultFilter.WorkplaceId = JSON.stringify(self.WorkplaceId());
                }
                else {
                    defaultFilter.WorkplaceId = null;
                }
            }
        }
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.ShiftbookId = ko.observable();
    self.ShiftbookName = ko.observable();
    self.ShiftbookIdOverwrite = ko.observable(false);
    self.ShiftbookId.subscribe(function () {
        if (initValues != null) {
            var defaultFilter = initValues.CustomFilter;
            if (defaultFilter != null) {
                defaultFilter.ShiftbookId = JSON.stringify(self.ShiftbookId());
            }
        }
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.ShiftgroupId = ko.observable();
    self.ShiftgroupName = ko.observable();
    self.ShiftgroupIdOverwrite = ko.observable(false);
    self.ShiftgroupId.subscribe(function () {
        if (initValues != null) {
            var defaultFilter = initValues.CustomFilter;
            if (defaultFilter != null) {
                defaultFilter.ShiftgroupId = JSON.stringify(self.ShiftgroupId());
            }
        }
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.GetCustomFilter = function () {
        if (self.ConfigurationItemTypeId() == null && self.ConfigurationItemStatusId() == null && self.WorkplaceId() == null && self.ShiftbookId() == null && self.QualificationId() == null && self.ShiftgroupId() == null) {
            return null;
        }
        else {
            return {
                ConfigurationItemTypeId: JSON.stringify(self.ConfigurationItemTypeId()),
                ConfigurationItemStatusId: JSON.stringify(self.ConfigurationItemStatusId()),
                WorkplaceId: JSON.stringify(self.WorkplaceId()),
                QualificationId: JSON.stringify(self.QualificationId()),
                ShiftbookId: JSON.stringify(self.ShiftbookId()),
                ShiftgroupId: JSON.stringify(self.ShiftgroupId())
            };
        }
    };
    self.HelperIsIdGiven = function (vartocheck) {
        vartocheck = ko.unwrap(vartocheck);
        if (typeof vartocheck === "undefined" || vartocheck === null || vartocheck === "null" || vartocheck === "[]") {
            return false;
        }
        if (vartocheck.length > 0) {
            return true;
        }
        else {
            return false;
        }
    };
    self.init = function () {
        return Bao.post("ExpandedSearchSynoset/GetPersonSystemSettings", function (result) {
            self.ShowShiftbook(result.showShiftbook);
            self.ShowShiftgroup(result.showShiftgroup);
            if (initValues != null) {
                var defaultFilter = initValues.CustomFilter;
                if (defaultFilter != null && defaultFilter["WorkplaceName"] != null && self.HelperIsIdGiven(defaultFilter["WorkplaceId"])) {
                    self.WorkplaceName(ko.unwrap(defaultFilter["WorkplaceName"]));
                }
                if (defaultFilter != null && defaultFilter["ShiftGroupName"] != null && self.HelperIsIdGiven(defaultFilter["ShiftgroupId"])) {
                    self.ShiftgroupName(ko.unwrap(defaultFilter["ShiftGroupName"]));
                }
                if (defaultFilter != null && defaultFilter["ShiftgroupIdOverwrite"] != null) {
                    self.ShiftgroupIdOverwrite(ko.unwrap(defaultFilter["ShiftgroupIdOverwrite"]));
                }
                if (defaultFilter != null && defaultFilter["ShiftbookIdOverwrite"] != null) {
                    self.ShiftbookIdOverwrite(ko.unwrap(defaultFilter["ShiftbookIdOverwrite"]));
                }
                if (defaultFilter != null && defaultFilter["ShiftbookId"] == null) {
                    self.ShiftbookIdOverwrite(true);
                }
                if (defaultFilter != null && defaultFilter["ShiftgroupId"] == null) {
                    self.ShiftgroupIdOverwrite(true);
                }
                if (defaultFilter != null && defaultFilter["ShiftbookName"] != null && self.HelperIsIdGiven(defaultFilter["ShiftbookId"])) {
                    self.ShiftbookName(ko.unwrap(defaultFilter["ShiftbookName"]));
                }
            }
            return self.LoadHtml();
        });
    };
    self.Reset = function () {
        self.ResetDefaultValues();
    };
    self.ResetDefaultValues = function () {
        if (self.defaultValuesCopy != null) {
            for (var k in self.defaultValuesCopy) {
                if (ko.isObservable(self.defaultValuesCopy[k])) {
                    initValues[k](ko.unwrap(self.defaultValuesCopy[k]));
                }
                else {
                    initValues[k] = self.defaultValuesCopy[k];
                }
            }
            for (var k in self.defaultValuesCopy.CustomFilter) {
                if (ko.isObservable(self.defaultValuesCopy.CustomFilter[k])) {
                    initValues.CustomFilter[k](ko.unwrap(self.defaultValuesCopy.CustomFilter[k]));
                }
                else {
                    initValues.CustomFilter[k] = self.defaultValuesCopy.CustomFilter[k];
                }
            }
        }
    };
    self.BeforeClose = function () {
        self.ResetDefaultValues();
    };
}
export default ExpandedSearchPerson;